export const SAVED_SEARCHES_NAME_COLUMN = "searchName";

export const NEW_ACCOUNTS_COLUMN = "newAccountsCount";
